<template>
    <div
        class="post"
        :class="[{ clickable: true, ebook: type === 'ebook', marked }, layoutType]"
        :title="post.title"
        @click.prevent="$emit('open-post', post)"
    >
        <div v-if="isVideo" class="post-overlay">
            <i class="far fa-play-circle fa-3x"></i>
        </div>

        <img v-if="post.imgUrl" class="post-img" :src="post.imgUrl" />
        <div class="post-img blank" v-else></div>

        <h2>{{ post.title }}</h2>
        <small v-if="!layoutType">{{ post.duration }}</small>
    </div>
</template>

<script setup>
defineProps({
    post: {
        type: Object,
        required: true,
    },

    type: String,
    isVideo: Boolean,
    marked: Boolean,
    layoutType: String,
})

defineEmits(['open-post'])
</script>

<style lang="scss" scoped>
.post {
    width: 320px;
    min-width: 320px;
    height: 250px;
    border-radius: 4px;
    background-color: $lighter-grey;
    margin-right: 12px;
    padding-bottom: 8px;
    position: relative;

    &.marked {
        width: 984px;
        min-width: 984px;
        height: 750px;
        margin: 12px 0;

        h2 {
            font-size: 18px;
        }
    }

    .post-overlay {
        position: absolute;
        z-index: 2;
        height: 75%;
        width: 100%;
        @include flex-center();
        background: rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease-in-out;

        i {
            color: white;
            transition: all 0.3s ease-in-out;
        }

        &:hover {
            background: rgba(0, 0, 0, 0.3);

            i {
                transform: scale(1.2);
            }
        }
    }

    .post-img {
        width: 100%;
        height: 75%;
        border-radius: 4px;
        object-fit: cover;

        &.blank {
            background-color: $light-grey;
        }
    }

    &:last-child {
        margin-right: 0px;
    }

    &.clickable {
        cursor: pointer;
    }

    &.ebook {
        /* width: 200px;
                min-width: 200px;
                height: 320px; */
        padding-bottom: 0;

        .post-img {
            height: 100%;
        }
    }

    h2,
    small {
        padding: 8px 8px 0;
        color: $dark-blue;
    }

    h2 {
        margin-bottom: 2px;
        font-weight: 500;
    }

    &.full-thumb {
        padding-bottom: 0;

        .post-img,
        .post-overlay {
            height: 100%;
        }

        h2 {
            position: absolute;
            bottom: 4%;
            left: 2%;
            color: white;
            text-shadow: 0px 0px 3px #000000;
        }
    }
}
</style>
